// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IU39l","introText":"styles_introText__RJnKe"};